const Login = () =>
  import(/* webpackChunkName: "LocalAuthUserManagement" */ '@/components/auth/Login');
const Signup = () =>
  import(/* webpackChunkName: "LocalAuthUserManagement" */ '@/components/auth/Signup');
const RequestPasswordReset = () =>
  import(
    /* webpackChunkName: "LocalAuthUserManagement" */ '@/components/auth/RequestPasswordReset'
  );
const ResetPassword = () =>
  import(/* webpackChunkName: "LocalAuthUserManagement" */ '@/components/auth/ResetPassword');
const UserList = () =>
  import(
    /* webpackChunkName: "LocalAuthUserManagementAdmin" */ '@/components/admin/users/UserList'
  );
const UserEditor = () =>
  import(/* webpackChunkName: "LocalAuthUserManagementAdmin" */ '@/components/shared/UserEditor');
const EmailView = () =>
  import(
    /* webpackChunkName: "LocalAuthUserManagementAdmin" */ '@/components/admin/emails/EmailView'
  );

const rootRoutes = [];

const coreRoutes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { publicRoute: true },
  },
  {
    path: '/signup',
    name: 'Signup',
    component: Signup,
    props: true,
    meta: { publicRoute: true },
  },
  {
    path: '/reset',
    name: 'RequestPasswordReset',
    component: RequestPasswordReset,
    meta: { publicRoute: true },
  },
  {
    path: '/reset/:token',
    name: 'ResetPassword',
    component: ResetPassword,
    props: true,
    meta: { publicRoute: true },
  },
  {
    path: '/users/me',
    name: 'MyUserEditor',
    component: UserEditor,
    props: { id: 'me' },
    meta: { labelKey: 'nav.myUserEditor' },
  },
];

const adminRoutes = [
  {
    path: 'users',
    name: 'UserList',
    component: UserList,
    meta: { labelKey: 'nav.userList' },
  },
  {
    path: 'users/:id',
    name: 'UserEditor',
    component: UserEditor,
    props: true,
  },
  {
    path: 'users/email',
    name: 'EmailView',
    component: EmailView,
  },
];

export default {
  root: rootRoutes,
  core: coreRoutes,
  admin: adminRoutes,
};
